<div class="mb-3">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <div class="position-relative">
    <span
      *ngIf="prefixIcon"
      class="position-absolute top-50 translate-middle-y ms-3 is-mask-field__icon"
    >
      <i [class]="'bx ' + prefixIcon + ' text-muted'"></i>
    </span>

    <input
      type="text"
      class="form-control"
      [class.is-invalid]="hasError"
      [style.padding-left]="prefixIcon ? '2.5rem' : null"
      [placeholder]="computedPlaceholder"
      [disabled]="isDisabled"
      [value]="displayValue"
      (input)="handleInput($event)"
      (blur)="handleBlur()"
      inputmode="numeric"
    >
  </div>

  <small *ngIf="helpText && !hasError" class="form-text text-muted">{{ helpText }}</small>
  <is-form-error *ngIf="control" [control]="control"></is-form-error>
</div>
